/**
	Функционал сортировки/пролистовки таблиц
*/

window.UARM_TMCE_UTIL = window.UARM_TMCE_UTIL || {};

var pagiNames = { // словарь имён инпутов и проч., которые неохота повторять сто раз
	inp_chbox: 'tsp_pagiControl-checkbox',
	inp_text: 'tsp_pagiControl-textbox',
	attr_data: 'data-tsp_pagiqty',
	attr_class: 'TSP_hasPagi'
}

var tsp_pagiControl = { // чекбокс И инпут поля "Пролистовка"
	type: 'form',
	labelGapCalc: false,
	padding: 0,
	layout: 'grid',
	columns: 2,
	defaults: {
		type: 'textbox',
		maxWidth: 50
	},
	items: [{
		name: pagiNames.inp_chbox,
		type: 'checkbox',
		label: 'Пролистовка',
		tooltip: 'Если установить эту галочку, под таблицей появятся стрелки для постраничного просмотра данных'
	}, {
		name: pagiNames.inp_text,
		type: 'textbox',
		label: 'кол-во страниц за раз',
		tooltip: 'по умолчанию 10',
		maxLength: 3
	}]
}

var tsp_sortControl = { // "Сортировка"
	name: 'tsp_sortControl-btnGroup',
	type: 'buttongroup',
	label: 'Колонки для сортировки',
	tooltip: 'В таблице есть объединенные ячейки, сортировка запрещена'
	// items назначаются в onInit
}

var sortIndicatorClass_forCell = 'TSP_sortCol';
var btnGroupLengthTreshHold = 5; // пороговое значение после кот. текст на кнопке будет обрезаться
var sortBtnCtrlPrefix = 'tsp_sort_col-';
var sortBtnCtrlPrefix_regex = new RegExp('^' + sortBtnCtrlPrefix + '(\\d+)$');
var getFirstRowCells = function(elm) {
	return $(elm).find('thead, tbody').find('tr').eq(0).find('td, th')
}
var hasJoined = function(elm) {
		return $(elm).find('thead, tbody, tfoot').find('td[rowspan], th[rowspan], td[colspan], th[colspan]').length > 0
		// Проверка на наличие объединённых ячеек, если есть - сортировка отменяется
	}
var hasSorting = function(elm) {
		return $(elm).find('thead, tbody, tfoot').find('td[class = "TSP_sortCol"], th[class = "TSP_sortCol"]').length > 0
		// Проверка на наличие сортируемых ячеек, если есть объединённые - сортировка отменяется
	}

// манипуляции с отличными от дефолтных (бордера и проч.)
// параметрами таблицы (а именно нужными для сортировки/пролистовки)
var tsp_getData = { // передаём форме данные из выбранного элемента
	onInit: function(dom, data, elm) {

		tsp_sortControl.disabled = hasJoined(elm); // сортировка отменяется если есть объединённые ячейки
		if (tsp_sortControl.disabled && elm.classList.contains('TSP_hasSort')) {
			elm.classList.remove('TSP_hasSort');
			if (elm.classList.length == 0) elm.removeAttribute('class');
		}

		var tempItems = [];

		getFirstRowCells(elm).each(function(ind, elm) {
			var $this = $(this);

			if (tsp_sortControl.disabled) {
				$this.removeClass(sortIndicatorClass_forCell);
				if ($this.attr('class') == '') $this.removeAttr('class');
			}

			var txt_full = $this.text().trim();
			var txt_isShort = txt_full.length <= btnGroupLengthTreshHold;
			var txt = txt_isShort ? txt_full : txt_full.substr(0, btnGroupLengthTreshHold) + '…';

			if (txt_full === '') {
				txt = '[кол.№' + (ind + 1) + ']'
			}

			var ctrlName = sortBtnCtrlPrefix + ind;
			var hasSort = $this.hasClass(sortIndicatorClass_forCell);
			let item = { // элементы типа button, см. http://www.tinymce.com/wiki.php/api4:class.tinymce.ui.Button
				name: ctrlName,
				text: txt,
				tooltip: txt_isShort ? false : txt_full,
				active: hasSort, // активность - это визуальное представление
				value: hasSort, // а значение - это то, что попадает в data
				onclick: function() {
					var changedState = !this.active(); // родного тоггла не нашлось, поэтому делаем через гет-сет
					this.active(changedState).value(changedState); // меняем отдельно визуальное представление и собственно значение
				},
				disabled: tsp_sortControl.disabled, // сортировка отменяется если есть объединённые ячейки
			};
			if (tsp_sortControl.disabled) item.tooltip = tsp_sortControl.tooltip;
			tempItems.push(item);
		})

		tsp_sortControl.items = tempItems;

		if (dom.getAttrib(elm, 'class').indexOf(pagiNames.attr_class) !== -1) { // если есть класс пролистовки - отмечаем чекбокс и указываем колво
			data[pagiNames.inp_chbox] = true;
			data[pagiNames.inp_text] = dom.getAttrib(elm, pagiNames.attr_data);
		}
		return data
	},
	onSubmit: function(dom, data, tableElm) { // берём из формы данные и интерпретируем их
		if (!!data[pagiNames.inp_chbox]) { // чекбокс отмечен - ставим дата-атрибут и класс
			var pagiqty = data[pagiNames.inp_text];
			dom.setAttrib(tableElm, pagiNames.attr_data, pagiqty);
			if (data['class'].indexOf(pagiNames.attr_class) === -1) {
				// если в классе не было признака пагинации - устанавливаем (в основной функции плагина класс уже установлен элементу)
				dom.setAttrib(tableElm, 'class', data['class'] + ' ' + pagiNames.attr_class)
			}
		}
		else { // прибиваем дата-атрибут и вырезаем наш класс
			tableElm.removeAttribute(pagiNames.attr_data);
			var elmClass = dom.getAttrib(tableElm, 'class').replace(pagiNames.attr_class, '');
			dom.setAttrib(tableElm, 'class', elmClass)
		}

		/* Применение данных сортировки */
		var $frc = getFirstRowCells(tableElm);
		var hasAtLeastOneSortCell = false;
		for (let k in data) {
			var execResult = sortBtnCtrlPrefix_regex.exec(k); // вычленяем индекс колонки
			// console.log('is sorting', k, !!execResult && data[k])
			if (!!execResult) { // и колонка подлежит сортировке
				var colIndex = execResult[1]; // если вдруг цифры не найдётся и colIndex будет undefined, не беда
				$frc.eq(colIndex).toggleClass(sortIndicatorClass_forCell, data[k]);
				if (data[k] === true) {
					hasAtLeastOneSortCell = true
				} else {
					// console.log('clear sort class', $frc.eq(colIndex));
					if ($frc.eq(colIndex)[0].classList.length == 0) $frc.eq(colIndex)[0].removeAttribute('class');
					delete data[k];
				}
			}
		}
		if ($(tableElm).hasClass('TSP_hasSort') || hasAtLeastOneSortCell) {
			$(tableElm).toggleClass('TSP_hasSort', hasAtLeastOneSortCell);
		}

		return data // TODO проверить нужно ли
	}
}

window.UARM_TMCE_UTIL.tsp_pagiControl = tsp_pagiControl;
window.UARM_TMCE_UTIL.tsp_sortControl = tsp_sortControl;
window.UARM_TMCE_UTIL.tsp_getData = tsp_getData;
